import '../styles/Gallery.css';
import traditionalHome from '../assets/bodyimgs.png';
import modernHome from '../assets/secondbody.jpeg';
import eveningHome from '../assets/garage-hero-1280.jpg';

const projects = [
  {
    image: traditionalHome,
    title: 'Traditional Wood Collection',
    detail: 'Warm carriage-house styling paired with a natural stone exterior.',
    position: 'center',
  },
  {
    image: modernHome,
    title: 'Modern Flush Panel',
    detail: 'A clean horizontal profile designed for contemporary architecture.',
    position: 'center',
  },
  {
    image: eveningHome,
    title: 'Custom Carriage Style',
    detail: 'Architectural doors that complement the home’s exterior materials.',
    position: 'center 68%',
  },
];

export default function Gallery() {
  return (
    <section id="Gallery" className="Gallery-Section" aria-labelledby="gallery-title">
      <div className="Gallery-Heading">
        <div>
          <p className="Section-Eyebrow Section-Eyebrow--light">OUR WORK</p>
          <h2 id="gallery-title" className="Gallery-Title">Doors that transform a home.</h2>
        </div>
        <p className="Gallery-Intro">
          Explore a few of the styles we install, from timeless carriage-house doors to streamlined modern profiles.
        </p>
      </div>

      <div className="Gallery-Grid">
        {projects.map((project, index) => (
          <article className="Gallery-Card" key={project.title}>
            <img
              src={project.image}
              alt={`${project.title} garage door installation`}
              loading="lazy"
              width="800"
              height="540"
              style={{ objectPosition: project.position }}
            />
            <div className="Gallery-Overlay" />
            <span className="Gallery-Number" aria-hidden="true">0{index + 1}</span>
            <div className="Gallery-Copy">
              <h3>{project.title}</h3>
              <p>{project.detail}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
